document.addEventListener('DOMContentLoaded', function () {

  /* ── Prevent <details> click-toggling (keep it only for height/structure) ── */
  document.querySelectorAll('.ddh-details > summary').forEach(function (s) {
  s.addEventListener('click', function (e) {
    // Allow <a> link clicks to work normally
    if (e.target.closest('a')) return;
    e.preventDefault();
  });
});

  /* ── Hover open/close for each menu wrapper ── */
  document.querySelectorAll('.ddh-menu-wrap').forEach(function (wrap) {
    var panel   = wrap.querySelector('.ddh-panel');
    var l2Items = panel ? panel.querySelectorAll('.ddh-l2-item') : [];
    var l3Lists = panel ? panel.querySelectorAll('.ddh-l3-list') : [];
    var delay;

    /* Full-width mega panels (real L3 content) span the whole nav and must NOT
       flip — only narrow/anchored dropdowns do. A panel is "anchored" (flippable)
       when its wrapper is positioned relative (simple dropdowns) OR it has no
       populated L3 grid (collapsed panels). */
    function isFlippablePanel() {
      if (!panel) return false;
      if (wrap.classList.contains('ddh-simple')) return true;   // simple "MORE"-style
      var l3panel = panel.querySelector('.ddh-l3-panel');
      if (!l3panel) return true;                                // no L3 area
      return !panel.querySelector('.ddh-l3-list li');           // L3 area empty
    }

    /* Decide left/right anchor. If opening rightward would push the panel past
       the right edge of the viewport, anchor it to the right so it opens
       leftward under its trigger. Uses the panel's real width when available,
       with a sensible fallback before first measurement. */
    function setPanelSide() {
      if (!isFlippablePanel()) { wrap.classList.remove('ddh-open-left'); return; }
      var trigger = wrap.querySelector('.ddh-details') || wrap;
      var rect = trigger.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      /* Measure panel width (temporarily reveal off-screen if hidden). */
      var pw = panel.offsetWidth;
      if (!pw) {
        var prevDisp = panel.style.display, prevVis = panel.style.visibility;
        panel.style.visibility = 'hidden';
        panel.style.display = 'block';
        pw = panel.offsetWidth;
        panel.style.display = prevDisp;
        panel.style.visibility = prevVis;
      }
      if (!pw) pw = 260; // fallback
      var margin = 8;
      if (rect.left + pw + margin > vw) {
        wrap.classList.add('ddh-open-left');   // anchor right → opens leftward
      } else {
        wrap.classList.remove('ddh-open-left'); // anchor left → opens rightward
      }
    }

    function open() {
      clearTimeout(delay);
      setPanelSide();
      wrap.classList.add('ddh-open');
      if (l2Items.length) {
        /* Activate the first L2 item that actually has L3 content,
           so the right panel is never blank on open. */
        var firstWithL3 = null;
        for (var i = 0; i < l2Items.length; i++) {
          var dl2 = l2Items[i].dataset.l2;
          var l3 = panel.querySelector('.ddh-l3-list[data-l2="' + dl2 + '"]');
          if (l3 && l3.querySelector('li')) { firstWithL3 = l2Items[i]; break; }
        }
        activateL2(firstWithL3 || l2Items[0]);
      }
    }

    function close() {
      delay = setTimeout(function () {
        wrap.classList.remove('ddh-open');
        wrap.classList.remove('ddh-open-left');
        clearActive();
      }, 120);
    }

    function clearActive() {
      l2Items.forEach(function (i) { i.classList.remove('active'); });
      l3Lists.forEach(function (l) { l.classList.remove('active'); });
    }

    function activateL2(item) {
      clearActive();
      item.classList.add('active');
      var l3 = panel.querySelector('.ddh-l3-list[data-l2="' + item.dataset.l2 + '"]');
      if (l3) l3.classList.add('active');
    }

    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', close);

    /* Keep open when moving into panel */
    if (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(delay); });
      panel.addEventListener('mouseleave', close);
    }

    /* L2 item hover switches L3 */
    l2Items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(delay);
        activateL2(item);
      });
    });
  });

});